import { useCallback, useState } from 'react';
import { useNotifications } from '../../../../../hooks/useNotifications';
import { useDebouncedFunction } from '../../../../../hooks/useDebouncedFunction';

export const useCustomListItems = ({ listId, page, parents, searchValue, getListItems }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({ listItems: [], total: 0, pageSize: 20 });
  const { showErrorNotification } = useNotifications();

  const getItems = useCallback(async () => {
    setIsLoading(true);
    try {
      const listData = await getListItems(listId, parents, page, searchValue);
      setData({
        listItems: listData.listItems,
        total: listData.total,
        pageSize: listData.pageSize,
      });
    } catch (error) {
      console.error(error);
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecords',
      });
    } finally {
      setIsLoading(false);
    }
  }, [listId, parents, page, searchValue, showErrorNotification, getListItems]);

  useDebouncedFunction(getItems, 300);

  return {
    isLoading,
    listItems: data.listItems,
    total: data.total,
    pageSize: data.pageSize,
  };
};
